import { render, staticRenderFns } from "./inventory-record.vue?vue&type=template&id=4d3af33d&scoped=true&"
import script from "./inventory-record.vue?vue&type=script&lang=ts&"
export * from "./inventory-record.vue?vue&type=script&lang=ts&"
import style0 from "./inventory-record.vue?vue&type=style&index=0&id=4d3af33d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3af33d",
  null
  
)

export default component.exports